<template>
	<div
		@click.stop="handleClick"
		ref="overlay"
		style="display: none; opacity: 0"
		:style="style"
		:class="overlayClasses"
	>
		<div
			ref="overlay-content"
			class="overlay-content"
			style="display: none; opacity: 0"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script>
/*

<<< README >>>

To allow for smooth fade in and fade out animations for the Overlay, it should always be in the DOM (i.e. not contrlled by v-if)

:open
The open state and animations are controlled by the :open prop
If :open is true on mount, the overlay will be rendered as open without a fade in animation

:position
Overlay could be position absolute or position fixed.

:contentTimeout
Miliseconds before the slot content starts to fade in

*/
// import { getSasonBasedOnDate } from "@/utils/utils";

export default {
	name: "Overlay",
	props: {
		open: {
			type: Boolean,
			default: false,
		},
		maxOpacity: {
			type: Number,
			default: 0.75,
		},
		color: {
			type: String,
			default: "black",
		},
		position: {
			type: String,
			default: "fixed",
		},
		speed: {
			type: Number,
			default: 250,
		},
		zIndex: {
			type: Number,
			default: 1000,
		},
		classes: {
			type: String,
			default: "",
		},
		additionalClasses: {
			type: String,
			default: "",
		},
		contentTimeout: {
			type: Number,
			default: 0,
		},
	},
	watch: {
		open(newVal) {
			try {
				if (newVal) {
					this.fadeIn();
				} else {
					this.fadeOut();
				}
			} catch (err) {
				err;
			}
		},
	},
	computed: {
		overlayClasses() {
			const defaultClasses =
				"overlay w-100 h-100 align-items-center justify-content-center";
			if (this.classes) {
				return this.classes;
			} else if (this.additionalClasses) {
				return [defaultClasses, this.additionalClasses].join(" ");
			} else {
				return defaultClasses;
			}
		},

		style() {
			return {
				background: this.color,
				position: this.position,
				transition: `opacity ${this.speed}ms ease-in-out`,
				"z-index": this.zIndex,
			};
		},
	},
	methods: {
		fadeIn(display = "flex") {
			// this.updateSeasonIfNeeded();

			this.$refs["overlay"].style.opacity = 0;
			this.$refs["overlay"].style.display = display;
			this.$refs["overlay-content"].style.display = "block";
			this.$nextTick(() => {
				this.$refs["overlay"].style.opacity = this.maxOpacity;
			});
			setTimeout(() => {
				this.$refs["overlay-content"].style.opacity = 1;
			}, this.contentTimeout);
		},
		fadeOut() {
			this.$refs["overlay"].style.opacity = 0;
			setTimeout(() => {
				this.$refs["overlay"].style.display = "none";
				this.$refs["overlay-content"].style.display = "none";
				this.$refs["overlay-content"].style.opacity = 0;
			}, this.speed);
		},
		handleClick() {
			this.$emit("overlayClicked");
		},
		// updateSeasonIfNeeded() {
		// 	const prevEndDate = window.location.href
		// 		.split("EndDate=")[1]
		// 		.split("&")[0];
		// 	if (prevEndDate != localStorage.getItem("newEndDate")) {
		// 		console.log("End Date CHANGED on the calendar!");
		// 		const selectedStartDate = window.location.href
		// 			.split("BeginDate=")[1]
		// 			.split("&")[0];

		// 		const baseURL = window.location.href.split("#season=")[0];
		// 		const paramsURLURL = window.location.href
		// 			.split("#season=")[1]
		// 			.substring(1);
		// 		const newSeason = getSasonBasedOnDate(selectedStartDate);
		// 		const newURL = `${baseURL}#season=${newSeason}${paramsURLURL}`;

		// 		window.location.href = newURL;

		// 		window.location.reload();
		// 	} else {
		// 		console.log("End Date didn't change on the calendar");
		// 	}
		// },
	},
	mounted() {
		if (this.open) {
			const overlay = this.$refs["overlay"];
			const overlayContent = this.$refs["overlay-content"];
			overlay.style.display = "flex";
			overlay.style.opacity = this.maxOpacity;
			overlayContent.style.display = "block";
			overlayContent.style.opacity = 1;
		}
	},
};
</script>

<style scoped>
.overlay {
	left: 0;
	top: 0;
}
.overlay-content {
	transition: opacity 100ms ease-in-out;
}
</style>
